<template>
  <nav>
    <div style="margin-top: 0px">
      <img alt="logo" src="@/assets/logo.jpg" style="height: 70px" />
    </div>

    <div class="d-flex f-align-center" style="margin: 30px 10px">
      <div class="avatar" style="text-align: center; line-height: 51px;max-width: 50px;">
        <v-icon>person</v-icon>
      </div>

      <div class="text-xs-left">
        <div style="color: black">Hello , {{ userName }}<br> ({{ roleName }})</div>
        <div
          style="
            margin-top: 5px;
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
          "
        >
          <div
            class="mr-1 m-hide"
            @click="home"
            style="padding: 5px 5px 10px 0; cursor: pointer"
          >
            首頁
          </div>
          <span class="m-hide">|</span>
          <div class="ml-1 pl-1" @click="logout" style="cursor: pointer">
            登出
          </div>
        </div>
      </div>
    </div>

    <div class="time-out">
      <v-icon class="mr-1" color="white" small>schedule</v-icon>{{ timer }}
      <span>秒後自動為您登出</span>
    </div>
    <v-list class="menu">
      <template v-for="(menuItem, menuIndex) in menuList">
        <router-link
          @click.native="checkUiVerFun(menuItem, menuIndex)"
          v-if="menuItem.childList.length == 0"
          :to="menuItem.url"
          tag="div"
          role="menu-items"
          exact
          :key="menuIndex"
        >
          <div :class="menuItem.menuCode !== 'FM1' ? 'm-hide' : ''">
          <div :class="menuIndex === tabActive ? 'active' : ''">
            <v-list-tile>
              <v-list-tile-action>
                <!-- <v-icon>star</v-icon> -->
                <!-- <v-icon>list_alt</v-icon> -->
                <v-icon>{{ menuItem.icon }}</v-icon>
                <!-- <menu-icon :type="menuItem.icon" class="menu_icon"></menu-icon> -->
              </v-list-tile-action>
              <v-list-tile-title>
                {{ menuItem.menuName }}
              </v-list-tile-title>
            </v-list-tile>
          </div>
          </div>
        </router-link>
        <v-list-group
          v-if="menuItem.childList.length > 0"
          :role="
            menuListInActive(menuItem.childList)
              ? 'menu-items active'
              : 'menu-items'
          "
          :key="menuIndex"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>{{ menuItem.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ menuItem.menuName }}</v-list-tile-title>
            </v-list-tile>
          </template>
          <template v-for="(menuItem2, menuIndex2) in menuItem.childList">
            <div
              @click="goCheck(menuItem2.url)"
              v-if="showMenu(menuItem2.url)"
              tag="div"
              :key="menuIndex2"
            >
              <v-list-tile>
                <v-list-tile-action> </v-list-tile-action>
                <v-list-tile-title>
                  {{ menuItem2.menuName }}
                </v-list-tile-title>
              </v-list-tile>
            </div>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </nav>
</template>
<script>
// import Watermark from '@/utils/watermark'
// import MenuIcon from "@/components/Base/SvgIcon/MenuIcon";
import types from "@/store/mutation-types";
import { createNamespacedHelpers, mapState } from "vuex";
const { mapActions } = createNamespacedHelpers("user");
const { mapActions: commonMapActions } = createNamespacedHelpers("common");
const isDev = process.env.NODE_ENV === "development";
let REMIND_TIME = 600;
export default {
  name: "the-menu",
  // components: { MenuIcon },
  data: () => ({
    roleName: '',
    admins: [
      ["Management", "people_outline"],
      ["Settings", "settings"],
    ],
    cruds: [
      ["Create", "add"],
      ["Read", "insert_drive_file"],
      ["Update", "update"],
      ["Delete", "delete"],
    ],
    clock: {
      type: Object,
    },
    timeOutMsg: false,
    userName: "",
    menuList: [],
    // carryYn: "",
    tabActive: null, // 當前選擇tab增加藍條樣式
    isDev: isDev,
    isLogout: false
  }),
  mounted: function () {
    window.clearInterval(this.clock);
    this.countDownTimer();
    let v = this.$store.getters["user/info"];
    this.userName = v.userName;
    this.roleName = v.roleName;
    // 先不開啟浮水印
    // this.$api.get('/public/getWatermarkTxt').then(r => {
    //   Watermark.set(r.data)
    // }).catch(() => {})

    this.checkUiVerFun();
  },
  created() {
    localStorage.removeItem('aTransCode')
    this.$store.commit(types.RESET_TIMER, true);
    REMIND_TIME = this.$store.getters["remindTimer"];

    let vm = this;
    // 先不開啟浮水印
    // this.$api.get('/public/getWatermarkTxt').then(r => {
    //   Watermark.set(r.data)
    // }).catch(() => {})

    let userInfo = this.$store.getters["user/info"];
    // this.carryYn = userInfo.carryYn;

    this.fetchAdmUsers().then((r) => {
      let admUser = r.data;
      if (admUser.pirYn === "Y" && admUser.mecYn === "Y") {
        this.policyAuth = true;
      }
    });
    this.$api.get("adm/com/roleMenu").then((r) => {
      if (r.data.length > 0) {
        r.data.forEach((item, index) => {
          if (item.depths === 1) {
            let url = "/";
            if (item.progCode !== null) {
              url = item.url;
            }
            vm.menuList.push({
              menuCode: item.menuCode,
              menuName: item.menuName,
              icon: item.description,
              url: url,
              childList: [],
            });
          }
        });
        r.data.forEach((item, index) => {
          if (item.depths === 2) {
            let url = "/";
            if (item.progCode !== null && item.url !== null) {
              url = item.url;
            }
            vm.menuList.forEach((mainItem) => {
              if (item.parentMenuCode === mainItem.menuCode) {
                mainItem.childList.push({
                  menuCode: item.menuCode,
                  menuName: item.menuName,
                  icon: item.description,
                  url: url,
                });
              }
            });
          }
        });
      }
    });
  },
  watch: {
    timer: function (val) {
      if (val === 0) {
        if (!this.isLogout) {
          this.isLogout = true
          this.removeInformation();
        }
      }
    },
  },
  computed: {
    ...mapState({
      timer: "timer",
    }),
    currentPage() {
      return this.$route.path;
    },
    ...mapState({
      timer: "timer",
    }),
    // carryYnName () {
    //   if (this.carryYn === 'Y') {
    //     return '(攜出)'
    //   }
    //   return ''
    // }
  },
  methods: {
    ...mapActions(["fetchUserInfo"]),
    ...commonMapActions(["fetchAdmUsers", "checkUiVer"]),
    countDownTimer() {
      this.clock = window.setInterval(() => {
        this.$store.commit(types.DECREMENT_TIMER);
        if (this.timer < 0) {
          window.clearInterval(this.clock);
        }
        if (this.timer <= REMIND_TIME) {
          if (!this.timeOutMsg) {
            let vm = this
            let min = REMIND_TIME / 60
            this.$confirm(
              min + "分鐘後將自動為您登出",
              (yn) => {
                if (yn) {
                  vm.$store.commit(types.RESET_TIMER, true);
                  vm.timeOutMsg = false;
                  vm.fetchUserInfo().then((response) => {
                    // 去後台繞一下重新refresh後台session
                    if (response.status === 401) {
                      // 已經被登出了
                      window.location.reload()
                    } else {
                      const isLogin = vm.$store.getters['user/isLogin']
                      if (!isLogin) {
                        // 已經被登出了
                        window.location.reload()
                      }
                    }
                  });
                } else {
                  if (!vm.isLogout) {
                    vm.isLogout = true
                    vm.removeInformation();
                  }
                }
              },
              {
                title: "注意",
                btnCancelText: "登出",
                btnConfirmText: "繼續使用",
              }
            );
            this.timeOutMsg = true;
          }
        }
      }, 200);
    },
    showMenu(url) {
      const isEditable = true;
      const isAppDev =
        process.env.VUE_APP_DEV_ENV === "development" ||
        process.env.NODE_ENV === "development";
      if (!(isAppDev || isEditable) && url === "proposal_new") {
        // if (this.carryYn === "Y") {
        //   return true;
        // } else {
        //   return false;
        // }
      }
      return true;
    },
    logout() {
      this.$confirm("是否確定要登出?").then((yn) => {
        if (yn) {
          this.$store.dispatch("common/postUserAccessLog", {
            progClassName: "logout",
            methodName: "登出",
          });
          this.removeInformation();
        }
      });
    },
    home() {
      this.fetchUserInfo().then((response) => {
        // 額外去判斷是否被登出了
        if (response.status === 401) {
          // 已經被登出了
          window.location.reload()
        } else {
          const isLogin = this.$store.getters['user/isLogin']
          if (!isLogin) {
            // 已經被登出了
            window.location.reload()
          }
        }
      });

      this.$store.dispatch("common/postUserAccessLog", {
        progClassName: "home",
        methodName: "首頁",
      });
      this.$router.replace("home").catch((e) => {});
    },
    removeInformation() {
      const $htmlScroll = document.documentElement; // 關閉 html scrollbar
      $htmlScroll.className = "";
      document.getElementsByClassName("v-btn__content")[0].click();
      window.clearInterval(this.clock); // timer 清除
      localStorage.removeItem("servMsg"); // 登出移除公告訊息
      sessionStorage.clear();
      this.$store.dispatch("user/logout");
    },
    menuListInActive(mainList) {
      let inList = false;
      mainList.forEach((item, index) => {
        if (item.url === this.$route.path) {
          inList = true;
        }
      });
      return inList;
    },
    checkUiVerFun(item, index) {
        if (item) {
          this.fetchUserInfo().then((response) => {
          // 額外去判斷是否被登出了
          if (response.status === 401) {
            // 已經被登出了
            window.location.reload()
          } else {
            const isLogin = this.$store.getters['user/isLogin']
            if (!isLogin) {
              // 已經被登出了
              window.location.reload()
            }
          }
        });

        this.$store.dispatch('common/postUserAccessLog', ({ progClassName: item.url, methodName: item.menuName }))
      }
      return this.checkUiVer().then((r) => {
        if (!r) {
          // 版號有異動
          this.$alert("版號有異動，重新載入!", (yn) => {
            window.location.reload();
          });
        } else {
          if (item && item.menuCode === "FM1") {
            this.$api.get("/ojt/common/getLmsUrl").then((r) => {
              if (r.data.length > 0) {
                window.open(r.data, "_blank", "noopener,noreferrer");
              } else {
                this.$alert("網址取得失敗");
              }
            });
          }
          else if (item && item.menuCode === "FM2") {
             const aTransCode =localStorage.getItem('aTransCode')
             if(aTransCode) {
               localStorage.removeItem('aTransCode')
               window.location.reload();
             }
          }
        }
        this.tabActive = index;
      });
    },
    goCheck(url) {
      this.checkUiVer().then((r) => {
        if (!r) {
          // 版號有異動
          this.$alert("版號有異動，重新載入!", (yn) => {
            this.go(url);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          });
        } else {
          this.go(url);
        }
      });
    },
    go(url) {
      if (url === "proposal_new") {
        if (this.policyAuth) {
          this.$api.get("/adm/com/inWorkTimInterval").then((r) => {
            if (r.data !== "Y") {
              this.$alert("所選擇之功能目前時段不開放始用");
            } else {
              let timeStamp = new Date().getTime().toString();
              this.$router.push("nopage").catch((e) => {});
              this.$router
                .push({
                  name: "proposal",
                  params: {
                    newFlag: timeStamp,
                  },
                })
                .catch((e) => {});
            }
          });
        } else {
          this.$alert("沒有要保書建置權限");
        }
      } else if (
        url === "/proposal" ||
        url === "/customerListOutputWorks" ||
        url === "/customerListRelease"
      ) {
        this.$api.get("/adm/com/inWorkTimInterval").then((r) => {
          if (r.data !== "Y") {
            this.$alert("所選擇之功能目前時段不開放始用");
          } else {
            this.$router.push(url).catch((e) => {});
          }
        });
      } else {
        this.$router.push(url).catch((e) => {});
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
nav {
  height: 100vh;
  background-color: #fff;
  position: fixed;
  overflow-y auto;
  width: 250px;
}

.link-finger {
  cursor: pointer;
}

.cus-name {
  font-size: $font-size-md;
  margin-bottom: 50px;
}

.v-list__tile__title {
  color: #000;
  font-weight: bolder;
}

.v-list__tile:hover {
  cursor: pointer;
}

.v-list__tile__action{
    min-width: 36px;
}

.v-list__tile {
  height: 60px !important;
}
.time-out {
    background: #1a396e;
    color: #fff;
    padding: 3px;
    display: flex;
    text-align: center;
    justify-content: center;
}
.avatar {
    height: 50px;
    background-color: #e8e7e7;
    border-radius: 50%;
    margin-right: 15px;
}
</style>
